module.exports = __webpack_public_path__ + "img/banner03.b0301f1b.jpg";